import Container from '@/components/Container';

export const PodcastDetailLoading = () => {
  return (
    <Container className="mt-sh-60 min-h-40">
      <div className="col-span-12 lg:col-start-3 lg:col-end-11">
        <div className="mb-sh-30 h-6 w-32 animate-pulse rounded bg-gray-200" />
        <div className="mb-sh-30 h-[300px] w-full animate-pulse rounded-lg bg-gray-200" />
        <div className="mb-sh-15 h-8 w-3/4 animate-pulse rounded bg-gray-200" />
        <div className="mb-sh-30 h-4 w-full animate-pulse rounded bg-gray-200" />
        <div className="mb-sh-30 h-16 w-full animate-pulse rounded-2xl border border-gray-200 bg-gray-100" />
        <div className="space-y-4">
          <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-5/6 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-4/6 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </Container>
  );
};
